import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import { ControlButtons } from "../controlButtons";

export const CsvViewer = ({ url, modal, handleExpand }) => {
  const [data, setData] = useState([]);
  const [cols, setCols] = useState([]);
  const [page, setPage] = useState(0);
  const limit = modal ? 15 : 5;

  useEffect(() => {
    let isMounted = true;

    const fetchCsvData = async (url) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        let fileObj = new File([blob], "file.csv", {
          type: "text/csv",
        });
        if (fileObj) {
          Papa.parse(fileObj, {
            complete: (result) => {
              console.log("Parsed CSV data:", result);
              let pages = [];
              for (let i = 0; i < result.data.length; i += limit) {
                pages.push(result.data.slice(i, i + limit));
              }
              setData(pages);
              setCols(result.meta.fields);
            },
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
          });
        }
      } catch (error) {
        console.error("Error fetching or parsing Csv file:", error);
      }
    };

    fetchCsvData(url);

    return () => {
      isMounted = false;
    };
  }, [url]);

  return (
    <div>
      <table>
        <thead>
          <tr>
            {cols.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.[page]?.map((row, index) => (
            <tr key={index}>
              {cols.map((col) => (
                <td key={col}>{row[col]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {data.length > 1 && (
        <ControlButtons
          page={page}
          data={data}
          handleExpand={handleExpand}
          setPage={setPage}
          modal={modal}
        />
      )}
      {/* <div
        className="d-flex justify-content-between"
        style={{
          border: "none",
          width: "660px",
          position: "sticky",
          left: "0",
        }}
      >
        <div style={{ border: "none" }} className="pt-4 pl-0 bg-white">
          <button
            onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
            disabled={page === 0}
          >
            <FiArrowLeft className="" />
          </button>
          <span className="">
            {page + 1}/{data.length}
          </span>
          <button
            onClick={() =>
              setPage((prev) => Math.min(prev + 1, data.length - 1))
            }
            disabled={page === data.length - 1}
          >
            <FiArrowRight className="" />
          </button>
        </div>
        {!modal && (
          <div style={{ border: "none" }} className="pt-4 pl-0 bg-white">
            <FiMaximize onClick={handleExpand} style={{ cursor: "pointer" }} />
          </div>
        )}
      </div> */}
    </div>
  );
};
